/* tslint:disable */
/* eslint-disable */
export enum WebhookEventType {
  ApplicationStatusUpdates = 'ApplicationStatusUpdates'
}
